import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import { createSelector } from 'reselect';
import * as _ from "../../../util/lodash";
import { getFormErrors, getFormValues, getFormValidators, getFieldValidators, getFieldContext, getFormFieldContexts, isFormDirty, isFormValid } from "./form-utils";
var Selectors = {};

var getForm = function getForm(state, formId) {
  return state.ck.form[formId];
};

var getForms = function getForms(state, formIds) {
  _reduceInstanceProperty(_).call(_, formIds, function (memo, formId) {
    memo[formId] = state[formId];
    return memo;
  }, {});
};

Selectors.getFormValues = createSelector([getForm], function (form) {
  return getFormValues(form);
});
Selectors.getFieldContext = createSelector([getForm, function (state, formId, fieldId) {
  return fieldId;
}], function (form, fieldId) {
  return getFieldContext(form, fieldId);
});
Selectors.getFormFieldContexts = createSelector([getForm], function (form) {
  return getFormFieldContexts(form);
});
Selectors.getFormErrors = createSelector([getForm], function (form) {
  return getFormErrors(form);
});
Selectors.getFieldValidators = createSelector([getForm, function (state, formId, fieldId) {
  return fieldId;
}], function (form, fieldId) {
  return getFieldValidators(form, fieldId);
});
Selectors.getFormValidators = createSelector([getForm], function (form) {
  return getFormValidators(form);
});
Selectors.isFormValid = createSelector([getForm], function (form) {
  return isFormValid(form);
});
Selectors.isFormDirty = createSelector([getForm], function (form) {
  return isFormDirty(form);
});
Selectors.getFieldValue = createSelector([getForm, function (state, formId, fieldId) {
  return fieldId;
}], function (form, fieldId) {
  return _.get(form, [fieldId, 'value']);
});
Selectors.getFieldErrors = createSelector([getForm, function (state, formId, fieldId) {
  return fieldId;
}], function (form, fieldId) {
  return _.get(form, [fieldId, 'errors'], []);
});
Selectors.isFieldValid = createSelector([getForm, function (state, formId, fieldId) {
  return fieldId;
}], function (form, fieldId) {
  return _.get(form, [fieldId, 'isValid']);
} //  may be derived later
);
Selectors.isFieldDirty = createSelector([getForm, function (state, formId, fieldId) {
  return fieldId;
}], function (form, fieldId) {
  return _.get(form, [fieldId, 'isDirty']);
} //  may be derived later
); //  state is always changing so probably not being memoized

Selectors.areFormsValid = createSelector([function (state, formIds) {
  return state;
}, function (state, formIds) {
  return formIds;
}], function (state, formIds) {
  return _everyInstanceProperty(_).call(_, formIds, function (formId) {
    return Selectors.isFormValid(state, formId);
  });
});
export default Selectors;
//# sourceMappingURL=selectors.js.map